export default class BPAbholungTerminWaehlenRequest {
  id: string
  type: string
  zeitpunkt: string
}
